module.exports = __webpack_public_path__ + "static/32948651_10216644889703567_7272828238697594880_n-782e8d52db1c1c761222043841d9bb73.jpg";